export default "__VITE_ASSET__BkiOHnjz__"